import * as React from 'react';
import CatalogCard from './CatalogCard';
import classNames from 'classnames';
import isEqual from 'react-fast-compare';
import noop from '@/utils/noop';
import styles from './CatalogGrid.module.scss';

type Props = {
    catalogCardClass?: string;
    catalogIds: number[];
    className?: string;
    followed?: boolean;
    homepage?: boolean;
    horizontal?: boolean;
    preview?: boolean;
    previewSellerId?: number;
    showSendSellerConsignmentMessageModal?: Function;
    trackClick?: Function;
};

const CatalogGrid = (props: Props) => {
    const {
        catalogCardClass,
        catalogIds,
        className,
        followed,
        homepage = false,
        horizontal = false,
        preview = false,
        previewSellerId,
        showSendSellerConsignmentMessageModal,
        trackClick,
    } = props;

    const lastIndex = catalogIds.length - 1;
    const catalogCardClasses = classNames(styles.card, catalogCardClass);

    const callback = React.useCallback((id) => trackClick(id), [trackClick]);

    const mapCatalogCards = React.useCallback(
        (id, index) => {
            const cardProps: any = {
                catalogId: id,
                followed,
                homepage,
                horizontal,
                key: index,
                last: index === lastIndex,
                preview,
                previewSellerId,
                showSendSellerConsignmentMessageModal,
            };

            if (trackClick) {
                cardProps.trackClick = callback;
            } else {
                cardProps.trackClick = noop;
            }

            if (horizontal) {
                return <CatalogCard {...cardProps} />;
            }

            return (
                <div className={catalogCardClasses} key={index}>
                    <CatalogCard {...cardProps} />
                </div>
            );
        },
        [
            callback,
            catalogCardClasses,
            followed,
            homepage,
            horizontal,
            lastIndex,
            preview,
            previewSellerId,
            showSendSellerConsignmentMessageModal,
            trackClick,
        ]
    );

    const classes = classNames(styles['catalog-grid'], className);
    return <div className={classes}>{catalogIds.map(mapCatalogCards)}</div>;
};

export default React.memo<Props>(CatalogGrid, isEqual);
